import { featuredOrder, orderGuides } from '@/mocks/routeData';

export default function OrderSection() {
  return (
    <section id="order" className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="flex items-center gap-3">
            <span className="h-px w-10 bg-orange-400" />
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-orange-600">ORDER · 观看顺序</span>
          </div>
          <h2 className="font-mag mt-3 text-2xl font-black text-stone-900 md:text-4xl">
            多部连看，先理清观看顺序再点开
          </h2>
        </div>
        <p className="max-w-sm text-sm leading-6 text-stone-500 md:text-right">
          剧场版、番外、特别篇该插在哪，这里都按无剧透原则排好了最佳路径。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-5">
        {/* 左侧重点顺序表 */}
        <article className="overflow-hidden rounded-2xl border border-stone-200/80 bg-white lg:col-span-2">
          <div className="bg-gradient-to-r from-orange-500 to-rose-500 px-6 py-5 text-white">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] opacity-80">{featuredOrder.kicker}</p>
            <h3 className="font-mag mt-2 text-xl font-bold leading-snug md:text-2xl">{featuredOrder.title}</h3>
            <p className="mt-2 text-[13px] leading-6 text-orange-50/90">{featuredOrder.desc}</p>
            <div className="mt-4 flex flex-wrap gap-2">
              {featuredOrder.stats.map((s) => (
                <div key={s[0]} className="rounded-lg bg-white/15 px-3 py-1.5 backdrop-blur">
                  <b className="block text-base font-black">{s[1]}</b>
                  <span className="text-[11px] text-orange-50">{s[0]}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="px-6 py-5">
            <p className="mb-3 text-sm font-bold text-stone-900">推荐观看步骤</p>
            <ol className="space-y-2">
              {featuredOrder.steps.map((s, i) => (
                <li key={s} className="flex items-center gap-3 rounded-lg px-2 py-1.5 transition hover:bg-orange-50">
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                      i === featuredOrder.steps.length - 1
                        ? 'bg-rose-500 text-white'
                        : 'bg-stone-100 text-stone-500'
                    }`}
                  >
                    {i + 1}
                  </span>
                  <span className="text-sm text-stone-700">{s}</span>
                  {i === featuredOrder.steps.length - 1 && (
                    <span className="ml-auto hidden rounded-full bg-rose-50 px-2 py-0.5 text-[11px] font-medium text-rose-600 sm:inline">
                      大结局
                    </span>
                  )}
                </li>
              ))}
            </ol>
            <div className="mt-4 rounded-xl bg-amber-50 p-4">
              <p className="mb-2 flex items-center gap-1.5 text-xs font-bold text-amber-700">
                <i className="ri-lightbulb-line" /> 避雷提示
              </p>
              <ul className="space-y-1.5 text-[13px] leading-5 text-amber-800/90">
                {featuredOrder.tips.map((t) => (
                  <li key={t} className="flex gap-1.5">
                    <span className="mt-1.5 h-1 w-1 shrink-0 rounded-full bg-amber-400" /> {t}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </article>

        {/* 右侧合集索引 */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-3">
          {orderGuides.map((g, i) => (
            <a
              key={g.title}
              href="#zone"
              className="group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-stone-200/80 bg-white transition hover:-translate-y-0.5 hover:border-orange-300"
            >
              <div className={`relative h-20 bg-gradient-to-r ${g.coverTone} px-5`}>
                <span className="absolute right-4 top-1/2 -translate-y-1/2 font-mag text-5xl font-black text-white/50">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="absolute left-4 top-1/2 -translate-y-1/2 rounded-md bg-white/80 px-2 py-0.5 text-[11px] font-bold text-stone-700">
                  {g.status}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="text-base font-bold leading-snug text-stone-900 group-hover:text-orange-700">
                  {g.title}
                </h3>
                <p className="mt-1 text-xs font-medium text-orange-600">{g.series}</p>
                <p className="mt-2 flex-1 text-[13px] leading-6 text-stone-500">{g.desc}</p>
                <div className="mt-3 flex items-center justify-between border-t border-dashed border-stone-200 pt-3 text-xs text-stone-400">
                  <span className="flex items-center gap-1"><i className="ri-list-ordered-2" /> {g.count}</span>
                  <span className="flex items-center gap-1"><i className="ri-fire-line text-orange-400" /> {g.hot}</span>
                  <span className="flex items-center gap-1 font-medium text-orange-600">
                    查看顺序 <i className="ri-arrow-right-line transition group-hover:translate-x-0.5" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}